/* ==========================================
   NAVURA - Bottom navigation

   - Measures its own height and the Shiprocket sticky Buy Now bar's height
     at runtime (rather than a hardcoded guess) and exposes both as CSS
     custom properties, so the nav sits above the Shiprocket bar instead of
     overlapping it, and page content gets the right bottom padding.
   - Hides while the category drawer or Dawn's own hamburger menu-drawer is
     open, so it never competes with either overlay.
========================================== */

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var nav = document.querySelector('[data-navura-bottom-nav]');
    if (!nav) return;

    var root = document.documentElement;

    function setNavHeight() {
      root.style.setProperty('--navura-bottom-nav-height', nav.offsetHeight + 'px');
    }

    setNavHeight();
    window.addEventListener('resize', setNavHeight);

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(setNavHeight).observe(nav);
    }

    // Shiprocket's sticky Buy Now bar is injected by an external script with
    // no fixed height we control locally, so measure it live if it appears.
    var shiprocketBar = document.getElementById('navuraStickyBar');

    function setShiprocketHeight() {
      var height = shiprocketBar && shiprocketBar.offsetHeight ? shiprocketBar.offsetHeight : 0;
      root.style.setProperty('--navura-shiprocket-height', height + 'px');
    }

    if (shiprocketBar) {
      setShiprocketHeight();
      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(setShiprocketHeight).observe(shiprocketBar);
      }
    } else if (typeof MutationObserver !== 'undefined') {
      // The bar may not exist yet on first paint (third-party script loads async).
      var bodyObserver = new MutationObserver(function () {
        var bar = document.getElementById('navuraStickyBar');
        if (!bar) return;
        shiprocketBar = bar;
        setShiprocketHeight();
        if (typeof ResizeObserver !== 'undefined') {
          new ResizeObserver(setShiprocketHeight).observe(bar);
        }
        bodyObserver.disconnect();
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () {
        bodyObserver.disconnect();
      }, 8000);
    }

    function hideNav() {
      nav.classList.add('navura-bottom-nav--hidden');
    }

    function showNav() {
      nav.classList.remove('navura-bottom-nav--hidden');
    }

    document.addEventListener('navura:category-drawer-open', hideNav);
    document.addEventListener('navura:category-drawer-close', showNav);

    // Dawn's hamburger menu-drawer toggles an [open] attribute on its
    // internal <details>; watch it the same way rather than adding a
    // second click listener on the hamburger button itself.
    var menuDrawer = document.querySelector('header-drawer details');
    if (menuDrawer) {
      var drawerObserver = new MutationObserver(function () {
        if (menuDrawer.hasAttribute('open')) {
          hideNav();
        } else {
          showNav();
        }
      });
      drawerObserver.observe(menuDrawer, { attributes: true, attributeFilter: ['open'] });
    }
  });
})();
